import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ConciergeErrorResponse } from 'src/api/concierge';

import { PromotionsEndpoints, getPromotionsList, PromotionList } from '../api';

type QueryConfig = UseQueryOptions<PromotionList, AxiosError<ConciergeErrorResponse>>;

export const useGetPromotions = (config: QueryConfig = {}) => {
    const userQuery = useQuery<PromotionList, AxiosError<ConciergeErrorResponse>>({
        queryKey: [PromotionsEndpoints.getPromotions],
        queryFn: getPromotionsList,
        ...config,
    });

    return userQuery;
};
